export const LISTING_LIMITS = {
    // Structural limits
    maxVariations: 3,
    maxOptionsPerVariation: 24,
    maxDescrSections: 5,
    maxImages: 20,
    // Listing title / subtitle
    maxTitleLength: 128,
    maxSubtitleLength: 256,
    // Name lengths
    maxNameLength: 60, // variations, options, etc.
    maxProfileNameLength: 64, // processing/shipping/return profile names
    // Price bounds (in cents)
    minPriceCents: 1, // $0.01
    maxPriceCents: 99_999_99, // $99,999.99
    // Rich text character limits (stripped HTML)
    maxDescrSectionBodyChars: 5000,
    maxReturnPolicyChars: 2000,
    maxPersonalizationHelperTextLength: 256,
    maxInventory: 9_999,
};
export const SHOP_LIMITS = {
    maxTitleLength: 128,
    maxClassificationLength: 64,
    maxLocationLength: 64,
    // Rich text character limit (stripped HTML)
    maxProfileRichTextChars: 5000,
};
export const SEARCH_QUERY_LIMITS = {
    minChars: 3,
    maxChars: 48,
};
export const DELIVERY_ESTIMATE_UNAVAILABLE_TEXT = 'Delivery estimate unavailable';
export var ImageVariant;
(function (ImageVariant) {
    ImageVariant["FULL"] = "full";
    ImageVariant["SMALL"] = "small";
})(ImageVariant || (ImageVariant = {}));
export var ImageUploadKind;
(function (ImageUploadKind) {
    ImageUploadKind["SHOP"] = "shop";
    ImageUploadKind["LISTING"] = "listing";
})(ImageUploadKind || (ImageUploadKind = {}));
// Absolute width ceiling applied to every uploaded image, in px, after the
// portrait-to-square crop (see useImageUpload.ts) — never upscaled past
// the source image's own width.
export const IMAGE_MAX_WIDTH = 3000;
// Small-variant target width, in px, derived from whatever width the full
// variant ended up at — never upscaled.
export const IMAGE_SMALL_WIDTH = 1000;
export const IMAGE_JPEG_QUALITY = 0.95;
// Listing images only: if encoding the full variant at IMAGE_MAX_WIDTH /
// IMAGE_JPEG_QUALITY produces a file bigger than this, the width is
// recalculated and stepped down until it fits — but never below
// IMAGE_LISTING_MIN_WIDTH, even if that leaves the file oversized.
export const IMAGE_LISTING_MAX_BYTES = 1_000_000;
export const IMAGE_LISTING_MIN_WIDTH = 1500;
// Suffix inserted before the file extension for a variant's storage key,
// e.g. "<uuid>-small.jpg". FULL has no suffix since it reuses the
// originally uploaded key.
export const imageVariantSuffix = (variant) => variant === ImageVariant.FULL ? '' : `-${variant}`;
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["PENDING"] = "PENDING";
    OrderStatus["CONFIRMED"] = "CONFIRMED";
    OrderStatus["SHIPPED"] = "SHIPPED";
})(OrderStatus || (OrderStatus = {}));
export var ShippingProvider;
(function (ShippingProvider) {
    ShippingProvider["UPS"] = "UPS";
    ShippingProvider["FEDEX"] = "FedEx";
    ShippingProvider["USPS"] = "USPS";
    ShippingProvider["DHL"] = "DHL";
})(ShippingProvider || (ShippingProvider = {}));
export var ShopRole;
(function (ShopRole) {
    ShopRole["OWNER"] = "owner";
})(ShopRole || (ShopRole = {}));
export var ReturnPolicyType;
(function (ReturnPolicyType) {
    ReturnPolicyType["STANDARD"] = "standard";
    ReturnPolicyType["CUSTOM"] = "custom";
    ReturnPolicyType["NO_RETURNS"] = "no_returns";
})(ReturnPolicyType || (ReturnPolicyType = {}));
export const US_STATES = [
    { value: 'AL', label: 'Alabama' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' },
    { value: 'DC', label: 'District of Columbia' },
];
export const US_STATE_CODES = new Set(US_STATES.map((s) => s.value));
